import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/views/Layout.vue'
import Login from '@/views/Login.vue'
import { setupRouterGuard } from './guard'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    meta: { requiresAuth: true },
    redirect: '/categories',
    children: [
      {
        path: 'categories',
        name: 'Categories',
        component: () => import('@/views/Category.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/Product.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'applicationScenarios',
        name: 'ApplicationScenarios',
        component: () => import('@/views/ApplicationScenarios.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'productApplication',
        name: 'ProductApplication',
        component: () => import('@/views/ProductApplication.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'banner',
        name: 'Banner',
        component: () => import('@/views/Banner.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'workshop',
        name: 'Workshop',
        component: () => import('@/views/Workshop.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'certification',
        name: 'Certification',
        component: () => import('@/views/Certification.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/User.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

setupRouterGuard(router)

export default router